<template>
  <div>
    <el-dialog
            :title="title"
            :visible="localVisible"
            width="75%"
            @close="onClose"
            class="shop-select-dialog"
            :close-on-click-modal="false"
    >
      <!-- 搜索区域 -->
      <div class="search-section">
        <el-form :model="searchForm" label-width="0" :inline="true" size="small" class="search-form">
          <el-form-item>
            <el-input
                    v-model="searchForm.keywords"
                    clearable
                    placeholder="请输入机构名称"
                    prefix-icon="el-icon-search"
                    @keyup.enter.native="handleSearch"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-select
                    v-model="searchForm.categoryId"
                    clearable
                    placeholder="请选择机构类别"
                    style="width: 180px;"
            >
              <el-option
                      v-for="item in categoryOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch" icon="el-icon-search">查询</el-button>
            <el-button @click="resetSearch" icon="el-icon-refresh">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格区域 -->
      <div class="table-section">
        <el-table
                ref="multipleTable"
                :data="mList"
                height="350"
                stripe
                size="small"
                v-loading="loading"
                element-loading-text="数据加载中..."
                element-loading-spinner="el-icon-loading"
                :header-cell-style="{
            background: 'linear-gradient(135deg, #f5f5f5 0%, #f5f5f5 100%)',
            color: '#333',
            fontWeight: 'bold',
            fontSize: '14px'
          }"
                :row-style="{cursor: 'pointer'}"
                @row-click="handleRowClick"
                highlight-current-row
                :current-row-key="currentRowKey"
        >
          <el-table-column label="选择" width="100" align="center">
            <template slot-scope="scope">
              <el-radio
                      v-model="selectedId"
                      :label="scope.row.id"
                      @click.native.stop="handleRadioClick(scope.row)"
                      class="custom-radio"
              ></el-radio>
            </template>
          </el-table-column>
          <el-table-column
                  label="编码"
                  width="160"
                  prop="sn"
                  :show-overflow-tooltip="true"
                  align="center"
          >
          </el-table-column>
          <el-table-column
                  label="名称"
                  min-width="180"
                  prop="name"
                  :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
                  label="类别"
                  min-width="150"
                  :show-overflow-tooltip="true"
                  align="center"
          >
            <template slot-scope="scope">
              <el-tag
                      v-if="scope.row.category && scope.row.category.name"
                      size="small"
                      :type="getCategoryTagType(scope.row.category.id)"
              >
                {{ scope.row.category.name }}
              </el-tag>
              <span v-else class="empty-text">-</span>
            </template>
          </el-table-column>
          <el-table-column
                  label="地址"
                  min-width="200"
                  prop="address"
                  :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
                  label="联系人手机号"
                  width="140"
                  prop="mobile"
                  :show-overflow-tooltip="true"
                  align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.mobile" class="mobile-text">{{ scope.row.mobile }}</span>
              <span v-else class="empty-text">-</span>
            </template>
          </el-table-column>
        </el-table>

        <!-- 空状态 -->
        <div v-if="mList.length === 0 && !loading" class="empty-state">
          <i class="el-icon-document-remove"></i>
          <p>暂无数据</p>
          <p class="empty-tip" v-if="hasActiveFilters">尝试调整筛选条件</p>
        </div>

        <!-- 分页 -->
        <div class="pagination-section" v-if="total > 0">
          <el-pagination
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pageNum"
                  :page-sizes="[10, 20, 30, 50]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  class="custom-pagination"
          >
          </el-pagination>
        </div>

        <!-- 底部操作按钮 -->
        <div class="dialog-footer">
          <div class="selected-info" v-if="curShop">
            已选择: <span class="selected-name">{{ curShop.name }}</span>
            <span class="selected-category" v-if="curShop.category">
              ({{ curShop.category.name }})
            </span>
          </div>
          <div class="action-buttons">
            <el-button @click="close" size="small">取消</el-button>
            <el-button
                    type="primary"
                    @click="ok"
                    size="small"
                    :disabled="!curShop"
                    icon="el-icon-check"
            >确定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name:'eShopList',
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      formData: {
        type: Object,
        default: null
      },
      title: {
        type: String,
        default: "选择机构",
      },
      closeForm: Function,
    },
    data(){
      return {
        localVisible:false,
        curShop: null,
        selectedId: null,
        id:'',
        name:'',
        searchForm: {
          keywords: '',
          categoryId: ''
        },
        categoryOptions: [],
        loading: false,
        mList:[],
        pageNum:1,
        pageSize:10,
        total:0,
      }
    },
    computed: {
      currentRowKey() {
        return this.curShop ? this.curShop.id : null;
      },
      hasActiveFilters() {
        return this.searchForm.keywords || this.searchForm.categoryId;
      }
    },
    mounted() {
      this.DataList();
      this.loadCategoryOptions();
    },
    methods:{
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },
      onClose(){
        this.$emit('update:visible',false)
        this.closeForm && this.closeForm();
      },
      close(){
        this.$emit('update:visible',false)
        this.closeForm && this.closeForm();
      },
      ok(){
        if (!this.curShop) {
          this.$message.warning('请先选择一个机构');
          return;
        }
        this.$emit('eventChoose',{id:this.id,name:this.name});
        this.$emit('update:visible',false)
        this.closeForm && this.closeForm();
      },
      async DataList(){
        this.loading = true;
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          page: this.pageNum,
          pageSize: this.pageSize,
          keywords: this.searchForm.keywords,
          category_id: this.searchForm.categoryId
        }
        try {
          const res = await this.$axios.shopListP(param);
          if(res.code == 200){
            this.mList = res.data.data
            this.total = res.data.total

            // 如果之前有选中项，尝试在加载数据后恢复选中状态
            if (this.selectedId) {
              const selectedRow = this.mList.find(item => item.id === this.selectedId);
              if (selectedRow) {
                this.curShop = selectedRow;
                this.id = selectedRow.id;
                this.name = selectedRow.name;
              } else {
                // 如果选中的行不在当前页，清空选中状态
                this.selectedId = null;
                this.curShop = null;
                this.id = '';
                this.name = '';
              }
            }
          } else {
            this.$message.error('数据加载失败');
          }
        } catch(error) {
          console.log(error);
          this.$message.error('数据加载失败');
        } finally {
          this.loading = false;
        }
      },
      // 加载类别选项
      async loadCategoryOptions() {
        try {
          // 假设有一个获取机构类别的接口
          const param = {
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token')
          };
          const res = await this.$axios.getShopCategories(param);
          if (res.code === 200) {
            this.categoryOptions = res.data;
          } else {
            // 如果接口不存在，使用模拟数据
            this.categoryOptions = [
              { id: 16, name: '运企' },
              { id: 13, name: '油站' }
            ];
          }
        } catch (error) {
          console.log('加载类别失败:', error);
          // 使用模拟数据作为备选
          this.categoryOptions = [
            { id: 16, name: '运企' },
            { id: 13, name: '油站' }
          ];
        }
      },
      // 单选按钮点击处理 - 阻止事件冒泡
      handleRadioClick(row) {
        // 使用 Vue.nextTick 确保在单选按钮状态更新后执行
        this.$nextTick(() => {
          // 如果点击的是已选中的行，则取消选择
          if (this.selectedId === row.id) {
            this.selectedId = null;
            this.curShop = null;
            this.id = '';
            this.name = '';
          } else {
            // 否则选择新行
            this.selectedId = row.id;
            this.curShop = row;
            this.id = row.id;
            this.name = row.name;
          }
        });
      },
      // 行点击处理
      handleRowClick(row, column, event) {
        // 如果点击的是单选按钮列，则不处理（因为单选按钮已经有自己的处理逻辑）
        if (event.target.closest('.el-radio')) {
          return;
        }

        // 处理行点击选择
        if (this.selectedId === row.id) {
          // 点击已选中行，取消选择
          this.selectedId = null;
          this.curShop = null;
          this.id = '';
          this.name = '';
        } else {
          // 选择新行
          this.selectedId = row.id;
          this.curShop = row;
          this.id = row.id;
          this.name = row.name;
        }
      },
      handleSearch() {
        this.pageNum = 1;
        this.DataList();
      },
      resetSearch() {
        this.searchForm.keywords = '';
        this.searchForm.categoryId = '';
        this.pageNum = 1;
        this.DataList();
      },
      // 获取类别标签样式
      getCategoryTagType(categoryId) {
        const types = ['', 'success', 'info', 'warning', 'danger'];
        return types[categoryId % types.length] || '';
      }
    },
    watch: {
      visible(val) {
        this.localVisible=val;
        if (val) {
          // 每次打开时重置搜索条件
          this.searchForm.keywords = '';
          this.searchForm.categoryId = '';
          this.curShop = null;
          this.selectedId = null;
          this.pageNum = 1;
          this.DataList();
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  .shop-select-dialog {
    /deep/ .el-dialog {
      border-radius: 8px;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);

      .el-dialog__header {
        padding: 15px 20px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border-radius: 8px 8px 0 0;

        .el-dialog__title {
          color: white;
          font-weight: 600;
          font-size: 16px;
        }

        .el-dialog__headerbtn {
          top: 15px;

          .el-dialog__close {
            color: white;
          }
        }
      }

      .el-dialog__body {
        padding: 20px;
      }
    }

    .search-section {
      margin-bottom: 15px;
      padding-bottom: 15px;
      border-bottom: 1px solid #ebeef5;

      .search-form {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        /deep/ .el-form-item {
          margin-bottom: 0;
          margin-right: 10px;
        }

        /deep/ .el-input {
          width: 240px;
        }
      }
    }

    .table-section {
      .empty-state {
        text-align: center;
        padding: 40px 0;
        color: #909399;

        i {
          font-size: 60px;
          margin-bottom: 15px;
          display: block;
        }

        p {
          margin: 0;
          font-size: 14px;
        }

        .empty-tip {
          font-size: 12px;
          color: #c0c4cc;
          margin-top: 5px;
        }
      }

      /deep/ .el-table {
        border: 1px solid #ebeef5;
        border-radius: 4px;

        .el-table__header-wrapper {
          border-radius: 4px 4px 0 0;
          overflow: hidden;
        }

        .custom-radio {
          /deep/ .el-radio__inner {
            width: 18px;
            height: 18px;

            &::after {
              width: 6px;
              height: 6px;
              background-color: #fff;
            }
          }

          /deep/ .el-radio__input.is-checked .el-radio__inner {
            border-color: #409EFF;
            background: #409EFF;
          }

          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: #409EFF;
          }
        }

        .mobile-text {
          color: #409EFF;
          font-weight: 500;
        }

        .empty-text {
          color: #c0c4cc;
          font-style: italic;
        }

        .el-table__row:hover {
          background-color: #f5f7fa;
        }

        .current-row {
          background-color: #ecf5ff !important;
        }

        // 修复单选按钮样式
        /deep/ .el-radio {
          margin: 0;
        }
      }

      .pagination-section {
        margin-top: 15px;
        display: flex;
        justify-content: flex-end;

        .custom-pagination {
          /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          }
        }
      }

      .dialog-footer {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 15px;
        border-top: 1px solid #ebeef5;

        .selected-info {
          color: #606266;
          font-size: 14px;

          .selected-name {
            color: #409EFF;
            font-weight: 500;
          }

          .selected-category {
            color: #67C23A;
            font-size: 12px;
          }
        }

        .action-buttons {
          /deep/ .el-button {
            min-width: 80px;
            border-radius: 4px;
          }
        }
      }
    }
  }

  /* 响应式调整 */
  @media (max-width: 992px) {
    .shop-select-dialog {
      /deep/ .el-dialog {
        width: 90% !important;
      }

      .search-section .search-form {
        flex-direction: column;
        align-items: flex-start;

        /deep/ .el-form-item {
          margin-bottom: 10px;
          margin-right: 0;
          width: 100%;

          .el-input, .el-select {
            width: 100% !important;
          }
        }
      }
    }
  }
</style>
